import React from "react";
import {connect} from 'react-redux';
import {Redirect} from "react-router-dom";

import {logoutUser} from './reducer';


class LogoutComponent extends React.Component {

    componentDidMount() {
        this.props.logoutUser();
    }

    render() {
        return (
            <Redirect to="/login"/>
        )
    }
}

function mapStateToProps(state) {
    return {};
}

export default connect(mapStateToProps, {logoutUser})(LogoutComponent);



// WEBPACK FOOTER //
// ./src/admin/security/LogoutComponent.js